var rechargeSubscriptionWidgetSheet = new CSSStyleSheet;
rechargeSubscriptionWidgetSheet.replaceSync(`
  .rc-selection__root{
    font-size: inherit;
    line-height: inherit;
  }
  .rc-purchase-option__label {
    padding: 8px 16px;
    font-size: 1.4rem;
    letter-spacing: .1rem;
    width: calc(100% - 32px);
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .rc-purchase-option__prices{
    margin-left: 0.5rem;
  }
  .rc-purchase-option__selector {
    font-size: inherit;
    font-weight: normal;
    min-width: 100px;
    padding: 0;
  }
  .rc-purchase-option__sub-container{
    padding: 1.5rem;
    padding-top: 0;
    gap: 1rem;
  }
  .rc-purchase-option__checked-indicator {
    margin-right: 0.75rem;
  }
  .strike-through{
    margin-right: 0.75rem;
    color: rgba(var(--color-foreground), .5);
  }
  .rc-selection__onetime .rc-price{
    display: none;
  }
`);
var rcRadioIconSheet = new CSSStyleSheet;
rcRadioIconSheet.replaceSync(`
  .rc-checked-icon,
  .rc-unchecked-icon {
    stroke-width: 1.5;
    overflow: visible;
  }
  .rc-checked-icon rect {
    width: 23px;
    height: 23px;
  }
  circle{
    r: 7.5
  }
`);
var rcBenefitsSheet = new CSSStyleSheet;
rcBenefitsSheet.replaceSync(`
  .rc-benefits__list {
    margin: 0.5rem 0;
    font-size: 1.4rem;
    display: flex;
    align-items: start;
  }
  .rc-benefits__list li{
    padding-left: 2em;
  }
  .rc-benefits__list li:before {
    width: 18px;
    height: 18px;
    margin-top: -3px;
  }
`);

const areElementsLoaded = async (document, selector) => {
  while ( document.querySelectorAll(selector).length <= 0) {
    await new Promise( resolve =>  requestAnimationFrame(resolve) )
  }
  return document.querySelectorAll(selector);
};
function insertAfter(referenceNode, newNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}


areElementsLoaded(document, 'recharge-subscription-widget').then((selector) => {
  
  selector.forEach(selector => {
    selector.shadowRoot.adoptedStyleSheets.push(rechargeSubscriptionWidgetSheet);
    console.log('pushed sheet to recharge-subscription-widget');
    areElementsLoaded(selector.shadowRoot, 'rc-radio-icon').then((selector) => {
      selector.forEach(selector => {
        selector.shadowRoot.adoptedStyleSheets.push(rcRadioIconSheet);
        console.log('pushed sheet to rc-radio-icon');
      });
    });
    areElementsLoaded(selector.shadowRoot, 'rc-benefits').then((selector) => {
      selector.forEach(selector => {
        selector.shadowRoot.adoptedStyleSheets.push(rcBenefitsSheet);
        console.log('pushed sheet to rc-benefits');
      });
    });
    areElementsLoaded(selector.shadowRoot, '.rc-selection__onetime .rc-price').then((selector) => {
      selector.forEach(selector => {
        let one_time_discount = document.querySelector("#one-time-discount");
        if (one_time_discount){
          let price = selector.innerHTML.replace(/<\!--.*?-->/g, "");
          let stripped_price = price.substr(1).replace(",", ".") * 1;
          let discounted_stripped_price = parseFloat(stripped_price) * (1 - parseFloat(one_time_discount.innerHTML));
          var bfp = document.createElement("strong");
          bfp.classList.add( "black-friday-price");
          bfp.innerHTML = "<div style='display: flex; flex-direction: column'><div style='text-align:right'><span class='strike-through text-muted'>" + price + " </span> £" + ((Math.ceil(discounted_stripped_price * 100) / 100).toFixed(2)) + "</div><div>(Black Friday: " + (one_time_discount.innerHTML * 100) + "% Off)</div></div>"
          insertAfter(selector, bfp);
          //selector.setAttribute('hidden', true);
               // selector.replaceWith(bfp);
        }
        else{
          var bfp = document.createElement("strong");
          bfp.classList.add( "black-friday-price");
          bfp.innerHTML = "<div style='display: flex; flex-direction: column'><div style='text-align:right'>" + selector.innerHTML + "</div></div>"
          insertAfter(selector, bfp);
          //selector.setAttribute('hidden', true);
               // selector.replaceWith(bfp);
        }
        let variant_labels = document.querySelectorAll(".product-form__input label");
        variant_labels.forEach(function(elem) {
          elem.addEventListener("click", (e) => {
            setTimeout(() => {
              if (one_time_discount){
                let price = selector.innerHTML.replace(/<\!--.*?-->/g, "");
                let stripped_price = price.substr(1).replace(",", ".") * 1;
                let discounted_stripped_price = parseFloat(stripped_price) * (1 - parseFloat(one_time_discount.innerHTML));
                selector.nextElementSibling.remove();
                bfp.innerHTML = "<div style='display: flex; flex-direction: column'><div style='text-align:right'><span class='strike-through text-muted'>" + price + " </span> £" + ((Math.ceil(discounted_stripped_price * 100) / 100).toFixed(2)) + "</div><div>(Black Friday: " + (one_time_discount.innerHTML * 100) + "% Off)</div></div>"
                insertAfter(selector, bfp);
                //selector.replaceWith(bfp);
          //selector.setAttribute('hidden', true);
              }
              else{
                selector.nextElementSibling.remove();
                bfp.innerHTML = "<div style='display: flex; flex-direction: column'><div style='text-align:right'>" + selector.innerHTML + "</div></div>"
                insertAfter(selector, bfp);
          //selector.setAttribute('hidden', true);
                
                //selector.replaceWith(bfp);
              }
            }, 40);
          });
        });
      });
    });
  });
});
